import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Verified-seller badge. Renders NOTHING when `verified` is false — per spec,
 * we never show an "unverified" state. Small blue ✔ next to the seller name.
 * Spec: WEB_MOBILE_SPEC_VERIFIED_SELLER.
 */
export default function VerifiedBadge({ verified, className = "" }) {
  if (!verified) return null;
  return (
    <span
      data-testid="verified-badge"
      title="Verified seller"
      aria-label="Verified seller"
      className={`inline-flex items-center align-middle text-[color:var(--brand-blue)] ${className}`}
    >
      <BadgeCheck className="w-4 h-4" strokeWidth={2.5} />
    </span>
  );
}
